module.exports = __webpack_public_path__ + "media/images/flags/32/South-Korea-dbf73d491c47c069b5927735ae0ad850.png";